import { combineReducers } from 'redux';
import auth from './auth.reducers';
import fetch from './fetch.reducers';
import resources from './resources.reducers';
import breadcrumbs from './breadcrumbs.reducers';

const store = () =>
  combineReducers({
    auth,
    fetch,
    resources,
    breadcrumbs
  });

export default store;
